'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

require('./LinkButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkButton = function LinkButton(props) {
    return _react2.default.createElement(_Button2.default, _extends({}, props, { className: (0, _classnames2.default)('LinkButton', props.className) }));
};

LinkButton.propTypes = {
    className: _propTypes2.default.string
};

exports.default = LinkButton;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/buttons/LinkButton.js
// module id = 74
// module chunks = 0